<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">지출등록</span>
            <span class="txt">지출내역을 등록, 수정,관리할 수있습니다.</span>
        </div>

        <div class="com-table-top">
            <span class="title">지출 등록</span>
        </div>
        <div class="com-table-wrap">
            <span class="top-title"><span class="title">지출 기본정보</span></span>
            <div class="com-card-input half-type">
                <div class="left-box full">
                    <div class="line">
                        <div class="division">
                            <span class="tit">
                                지출구분
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <div class="com-radio">
                                    <input
                                        id="radio-s1-1"
                                        v-model="expenseType"
                                        name="radio-s1-1"
                                        type="radio"
                                        value="C"
                                        @click="initType"
                                    />
                                    <label for="radio-s1-1">변동지출</label>
                                </div>
                                <div class="com-radio">
                                    <input
                                        id="radio-s1-2"
                                        v-model="expenseType"
                                        name="radio-s1-2"
                                        type="radio"
                                        value="F"
                                        @click="initType"
                                    />
                                    <label for="radio-s1-2">고정지출</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="!billId" class="line">
                        <span class="tit">
                            지출항목
                            <span class="imp">*</span>
                        </span>
                        <div class="input-cnt">
                            <select-form
                                v-if="expenseType == 'C'"
                                :select-data="['선택', ...expenseList]"
                                :select-value="['', ...expenseList]"
                                :selected-value="itemValue"
                                class="w220"
                                @update:set="(val) => (itemValue = val)"
                            ></select-form>
                            <select-form
                                v-if="expenseType == 'F'"
                                :select-data="['선택', ...fixList]"
                                :select-value="['', ...fixValList]"
                                class="w220"
                                @update:selected="(val) => (itemValue2 = val)"
                                @update:set="(val) => (itemValue3 = val)"
                            ></select-form>
                            <div class="com-check">
                                <input id="check-t1" v-model="directinput" name="check-t1" type="checkbox" />
                                <label for="check-t1">직접입력</label>
                            </div>
                            <input
                                v-model="directExpenseItem"
                                :disabled="directinput == false"
                                class="w220"
                                type="text"
                            />
                        </div>
                    </div>
                    <div v-if="billId" class="line">
                        <!--billid가 있을때-->
                        <input v-model="editExpenseItem" class="w220" disabled type="text" />
                    </div>
                    <div class="line">
                        <span class="tit">
                            지출금액
                            <span class="imp">*</span>
                        </span>
                        <div class="input-cnt">
                            <input
                                v-model="expensePrice"
                                class="w220"
                                type="text"
                                @keypress="isNumber($event)"
                                @keyup="onKeyUpPrice"
                            />
                            <span class="txt">원</span>
                        </div>
                    </div>
                    <div class="line">
                        <span class="tit">
                            지출수량
                            <span class="imp">*</span>
                        </span>
                        <div class="input-cnt">
                            <input
                                v-model="expenseCount"
                                class="w220"
                                type="text"
                                @keypress="isNumber($event)"
                                @keyup="onKeyUpPrice"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <span class="top-title"><span class="title">지출 결제정보</span></span>

            <div class="com-card-form only-payment">
                <div class="middle-area">
                    <!-- 결제 정보 -->
                    <div class="payment-box">
                        <span class="title">결제정보 - 1</span>
                        <ul class="info-list">
                            <li>
                                <span class="tit">
                                    <span class="imp">*</span>
                                    결제수단 :
                                </span>
                                <div class="info">
                                    <div class="flex">
                                        <div class="com-radio">
                                            <input
                                                id="radio-1-1"
                                                v-model="billingPayType"
                                                name="radio-1"
                                                type="radio"
                                                value="C"
                                            />
                                            <label for="radio-1-1">카드</label>
                                        </div>
                                        <div class="com-radio">
                                            <input
                                                id="radio-1-2"
                                                v-model="billingPayType"
                                                name="radio-1"
                                                type="radio"
                                                value="L"
                                            />
                                            <label for="radio-1-2">현금</label>
                                        </div>
                                        <div class="com-radio">
                                            <input
                                                id="radio-1-3"
                                                v-model="billingPayType"
                                                name="radio-1"
                                                type="radio"
                                                value="B"
                                            />
                                            <label for="radio-1-3">계좌이체</label>
                                        </div>
                                        <div class="com-radio">
                                            <input
                                                id="radio-1-4"
                                                v-model="billingPayType"
                                                name="radio-1"
                                                type="radio"
                                                value="M"
                                            />
                                            <label for="radio-1-4">마일리지</label>
                                        </div>
                                        <div class="com-radio">
                                            <input
                                                id="radio-1-5"
                                                v-model="billingPayType"
                                                name="radio-1"
                                                type="radio"
                                                value="E"
                                            />
                                            <label for="radio-1-5">기타</label>
                                        </div>
                                    </div>

                                    <div v-show="billingPayType == 'C'" class="card-radio-box">
                                        <div class="com-radio-btn">
                                            <input
                                                id="radio-2-1"
                                                v-model="billingPayCompany"
                                                name="radio-2"
                                                type="radio"
                                                value="KB"
                                            />
                                            <label for="radio-2-1">KB국민</label>
                                        </div>
                                        <div class="com-radio-btn">
                                            <input
                                                id="radio-2-2"
                                                v-model="billingPayCompany"
                                                name="radio-2"
                                                type="radio"
                                                value="BC"
                                            />
                                            <label for="radio-2-2">비씨</label>
                                        </div>
                                        <div class="com-radio-btn">
                                            <input
                                                id="radio-2-3"
                                                v-model="billingPayCompany"
                                                name="radio-2"
                                                type="radio"
                                                value="SM"
                                            />
                                            <label for="radio-2-3">삼성</label>
                                        </div>
                                        <div class="com-radio-btn">
                                            <input
                                                id="radio-2-4"
                                                v-model="billingPayCompany"
                                                name="radio-2"
                                                type="radio"
                                                value="HY"
                                            />
                                            <label for="radio-2-4">현대</label>
                                        </div>
                                        <div class="com-radio-btn">
                                            <input
                                                id="radio-2-5"
                                                v-model="billingPayCompany"
                                                name="radio-2"
                                                type="radio"
                                                value="LO"
                                            />
                                            <label for="radio-2-5">롯데</label>
                                        </div>
                                        <div class="com-radio-btn">
                                            <input
                                                id="radio-2-6"
                                                v-model="billingPayCompany"
                                                name="radio-2"
                                                type="radio"
                                                value="SH"
                                            />
                                            <label for="radio-2-6">신한</label>
                                        </div>
                                        <div class="com-radio-btn">
                                            <input
                                                id="radio-2-7"
                                                v-model="billingPayCompany"
                                                name="radio-2"
                                                type="radio"
                                                value="WR"
                                            />
                                            <label for="radio-2-7">외한</label>
                                        </div>
                                        <div class="com-radio-btn">
                                            <input
                                                id="radio-2-8"
                                                v-model="billingPayCompany"
                                                name="radio-2"
                                                type="radio"
                                                value="HN"
                                            />
                                            <label for="radio-2-8">하나</label>
                                        </div>
                                        <div class="com-radio-btn">
                                            <input
                                                id="radio-2-9"
                                                v-model="billingPayCompany"
                                                name="radio-2"
                                                type="radio"
                                                value="NH"
                                            />
                                            <label for="radio-2-9">NH농협</label>
                                        </div>
                                        <div v-show="isMoreCard" class="com-radio-btn">
                                            <input
                                                id="radio-2-10"
                                                v-model="billingPayCompany"
                                                name="radio-2"
                                                type="radio"
                                                value="WT"
                                            />
                                            <label for="radio-2-10">우리</label>
                                        </div>
                                        <div v-show="isMoreCard" class="com-radio-btn">
                                            <input
                                                id="radio-2-11"
                                                v-model="billingPayCompany"
                                                name="radio-2"
                                                type="radio"
                                                value="CT"
                                            />
                                            <label for="radio-2-11">씨티</label>
                                        </div>
                                        <div v-show="isMoreCard" class="com-radio-btn">
                                            <input
                                                id="radio-2-12"
                                                v-model="billingPayCompany"
                                                name="radio-2"
                                                type="radio"
                                                value="SUH"
                                            />
                                            <label for="radio-2-12">수협</label>
                                        </div>
                                        <div v-show="isMoreCard" class="com-radio-btn">
                                            <input
                                                id="radio-2-13"
                                                v-model="billingPayCompany"
                                                name="radio-2"
                                                type="radio"
                                                value="CU"
                                            />
                                            <label for="radio-2-13">신협</label>
                                        </div>
                                        <div v-show="isMoreCard" class="com-radio-btn">
                                            <input
                                                id="radio-2-14"
                                                v-model="billingPayCompany"
                                                name="radio-2"
                                                type="radio"
                                                value="KDB"
                                            />
                                            <label for="radio-2-14">KDB산업</label>
                                        </div>
                                        <div v-show="isMoreCard" class="com-radio-btn">
                                            <input
                                                id="radio-2-15"
                                                v-model="billingPayCompany"
                                                name="radio-2"
                                                type="radio"
                                                value="KG"
                                            />
                                            <label for="radio-2-15">광주</label>
                                        </div>
                                        <div v-show="isMoreCard" class="com-radio-btn">
                                            <input
                                                id="radio-2-16"
                                                v-model="billingPayCompany"
                                                name="radio-2"
                                                type="radio"
                                                value="JB"
                                            />
                                            <label for="radio-2-16">전북</label>
                                        </div>
                                        <div v-show="isMoreCard" class="com-radio-btn">
                                            <input
                                                id="radio-2-17"
                                                v-model="billingPayCompany"
                                                name="radio-2"
                                                type="radio"
                                                value="JJ"
                                            />
                                            <label for="radio-2-17">제주</label>
                                        </div>
                                        <div v-show="isMoreCard" class="com-radio-btn">
                                            <input
                                                id="radio-2-18"
                                                v-model="billingPayCompany"
                                                name="radio-2"
                                                type="radio"
                                                value="KA"
                                            />
                                            <label for="radio-2-18">케이뱅크</label>
                                        </div>
                                        <div v-show="isMoreCard" class="com-radio-btn">
                                            <input
                                                id="radio-2-10"
                                                v-model="billingPayCompany"
                                                name="radio-2"
                                                type="radio"
                                                value="KAKAO"
                                            />
                                            <label for="radio-2-10">카카오뱅크</label>
                                        </div>
                                        <div v-show="isMoreCard" class="com-radio-btn">
                                            <input
                                                id="radio-2-19"
                                                v-model="billingPayCompany"
                                                name="radio-2"
                                                type="radio"
                                                value="ET"
                                            />
                                            <label for="radio-2-19">기타</label>
                                        </div>
                                        <button v-show="!isMoreCard" class="more-btn" @click="isMoreCard = true">
                                            + 더보기
                                        </button>
                                    </div>
                                </div>
                            </li>
                            <!-- 결제수단 현금,계좌이체 일시 -->
                            <li v-show="billingPayType == 'L' || billingPayType == 'B'">
                                <span class="tit">영수증발행 :</span>
                                <div class="center-line flex">
                                    <div class="flex">
                                        <div class="com-radio">
                                            <input
                                                id="radio-money-1"
                                                v-model="billingReceiptType"
                                                name="radio-money"
                                                type="radio"
                                                value="N"
                                            />
                                            <label for="radio-money-1">미신청</label>
                                        </div>
                                        <div class="com-radio">
                                            <input
                                                id="radio-money-2"
                                                v-model="billingReceiptType"
                                                name="radio-money"
                                                type="radio"
                                                value="C"
                                            />
                                            <label for="radio-money-2">현금영수증</label>
                                        </div>
                                        <div class="com-radio">
                                            <input
                                                id="radio-money-3"
                                                v-model="billingReceiptType"
                                                name="radio-money"
                                                type="radio"
                                                value="T"
                                            />
                                            <label for="radio-money-3">세금계산서</label>
                                        </div>

                                        <div class="" style="margin-left: 4rem">
                                            <input class="w220" placeholder="번호입력" type="text" />
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <!-- //결제수단 현금,계좌이체 일시 -->
                            <!-- 결제수단 마일리지 일시 -->
                            <li v-show="billingPayType == 'M'">
                                <span class="tit">보유 마일리지 :</span>
                                <div class="center-line">
                                    <div class="txt-info">300,000 원</div>
                                    <div class="input-line">
                                        <div class="com-check">
                                            <input id="check-mileage-1" name="check-mileage" type="checkbox" />
                                            <label for="check-mileage-1">모두사용</label>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li v-show="billingPayType == 'M'">
                                <span class="tit">사용 마일리지 :</span>
                                <div class="info">
                                    <input class="w220" type="text" />
                                    <span class="txt">원</span>
                                </div>
                            </li>
                            <li v-show="billingPayType == 'M'">
                                <span class="tit">마일리지 잔액 :</span>
                                <div class="info">
                                    <span class="txt-info">0 원</span>
                                </div>
                            </li>
                            <!-- //결제수단 마일리지 일시 -->
                            <li>
                                <span class="tit">
                                    <span class="imp">*</span>
                                    결제일자 :
                                </span>
                                <div class="info">
                                    <single-calendar
                                        :start-date="timeDate"
                                        class="w220"
                                        @update="updateDate"
                                    ></single-calendar>
                                </div>
                            </li>
                            <li>
                                <span class="tit">
                                    <span class="imp">*</span>
                                    등록자 :
                                </span>
                                <div class="info">
                                    <select-form
                                        :select-data="['선택', ...staffList]"
                                        :select-value="['', ...staffValueList]"
                                        :selected-value="billingRegistStaffId"
                                        class="w220"
                                        @update:set="(val) => (billingRegistStaffId = val)"
                                    ></select-form>
                                </div>
                            </li>
                            <li>
                                <span class="tit">메모</span>
                                <div class="info">
                                    <textarea 
                                     v-model="memo"
                                    class="com-textarea w1000"></textarea>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="bottom-btn">
            <router-link class="com-btn" to="/madmin/sales/expense">취소</router-link>
            <!-- <button class="com-btn">취소</button> -->
            <button v-if="!billId" class="com-btn blue" @click="expensePost">등록</button>
            <button v-if="billId" class="com-btn blue" @click="expenseEdit">수정</button>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import moment from 'moment';

export default {
    name: 'SalesExpenseEdit',
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        staffId() {
            const { getters } = this.$store;
            return getters['auth/staffId'];
        },
    },
    watch: {
        itemValue(newValue) {
            console.log(newValue);
            this.expenseItem = newValue;
        },
        itemValue2(newValue) {
            console.log(newValue);
            this.expenseItem = newValue;
        },
        itemValue3(newValue) {
            console.log(newValue);
            this.expensePrice = newValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        staffName(newValue) {
            console.log(newValue);
            if (!this.billId) {
                this.billingRegistStaffId = newValue;
            }
            if (this.billId) {
                this.billingRegistStaffId = newValue;
            }
        },
    },
    data() {
        return {
            billId: this.$route.query.billId,
            isMoreCard: false,
            directinput: false, // 직접입력 버튼
            centerId: '',
            centerName: '',
            centerStaffId: '',

            // 지출구분
            expenseType: 'C',
            // 지출항목
            expenseItem: '',
            // 지출금액
            expensePrice: 0,
            // 지출수량
            expenseCount: '',
            // 결제정보(2)
            billingPayType: 'C',
            billingPayCompany: 'KB',
            // 영수증발행
            billingReceiptType: 'N',
            // 결제일자
            timeDate: moment().format('YYYY-MM-DD'),
            // 등록자
            billingRegistStaffId: '',
            // 메모
            memo : '',
            // 결제시간
            timeTime: '',

            centerStaffList: [], // centerStaff 이름 목록
            centerStaffValueList: [], // centerStaff ID 목록

            expenseList: [],
            expenseValList: [],
            fixList: [],
            fixValList: [],

            itemValue: '',
            itemValue2: '',
            itemValue3: '',
            staffName: '',
            directExpenseItem: '', // 직접입력시
            editExpenseItem: '',

            staffList: [],
            staffValueList: [],
            selectedSeller: '',
        };
    },
    mounted() {
        this.centerId = this.cId; // 센터 Id
        (this.billingRegistStaffId = parseInt(this.staffId)), // 스태프아이디 설정
            this.init(); // 초기화 실행
    },
    methods: {
        // 초기화
        async init() {
            if (this.billId != undefined) {
                this.fetchEditExpenseList();
            }
            await this.fetchCenterStaffList(); // 매출직원, 담당강사 목록 가져오기
            await this.fetchExpenseList(); // 지출항목 템플릿 리스트 가져오기
            await this.onStaffList();
        },
        // 등록기능
        async expensePost() {
            try {
                const validate = this.validateValues();
                if (!validate.result) {
                    alert(validate.msg);
                    return false;
                }
                const { data } = await this.getExpensePost();
                console.log(data);
                alert('등록이 완료되었습니다.');
                this.$router.push({ name: 'SalesExpense' });
            } catch (error) {
                console.log('등록이 안됨');
                console.log(error);
            }
        },
        // 등록 api
        getExpensePost() {
            // 스웨거 검색: 센터 지출금액 등록
            return api.post(`/admin/api/centerBill/expense`, {
                centerId: this.centerId,
                centerBillingId: 0, // 값수정필요
                timeDate: this.timeDate,
                timeTime: moment().utc().format('YYYY-MM-DD HH:mm:ss'), // time with tiemzone
                billingPayType: this.billingPayType,
                billingPayCompany: this.billingPayCompany,
                billingReceiptType: this.billingReceiptType,
                billingRegistStaffId: this.billingRegistStaffId,
                centerName: this.centerName,
                expenseType: this.expenseType,
                expenseItem: this.directExpenseItem == '' ? this.expenseItem : this.directExpenseItem,
                expensePrice: this.getPureNumber(this.expensePrice) * this.getPureNumber(this.expenseCount),
                expenseCount: this.expenseCount,
                memo : this.memo
            });
        },
        // 변동지출 클릭시 목록 조회
        async fetchExpenseList() {
            try {
                const { data } = await this.varExpenseList(); // 조건에 맞게 가져와야함.
                console.log('변동지출', data);
                data.forEach((g) => {
                    if (g.expenseType == 'C') {
                        this.expenseList.push(g.expenseItem);
                        this.expenseValList.push(g.templateId);
                    } else if (g.expenseType == 'F') {
                        this.fixList.push(g.expenseItem);
                        this.fixValList.push(g.expensePrice);
                    }
                });
            } catch (error) {
                console.log('값을 가져오는데 실패했습니다.');
                console.log(error);
            }
        },
        // 변동지출 목록 조회 api
        varExpenseList() {
            return api.get(`/admin/api/centerBill/expenseItemTemplate/${this.centerId}`);
        },
        // 매출직원, 담당강사 목록 가져오기
        async fetchCenterStaffList() {
            try {
                const { data } = await this.sendGetCenterStaffList();
                data.forEach((d) => {
                    this.centerStaffList.push(d.name);
                    this.centerStaffValueList.push(d.centerStaffId);
                });
            } catch (error) {
                alert('직원 목록을 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 직원 목록 API 호출
        sendGetCenterStaffList() {
            return api.get(`/admin/api/center/${this.centerId}/staff/teachers/list`);
        },
        // 지출등록에 대한 수정 아이템
        async fetchExpenseItem() {
            try {
                const { data } = await this.expenseEditItem();
            } catch (error) {
                console.log('error');
                console.log(error);
            }
        },
        // 수정을 위한 데이터 조회
        async fetchEditExpenseList() {
            try {
                const { data } = await this.fetchGetEditExpenseList();
                console.log('수정을위한 데이터 준비', data);
                // 지출구분
                this.expenseType = data.expenseType;
                // 지출항목
                this.editExpenseItem = data.expenseItem;
                // 지출금액
                this.expensePrice = data.expensePrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                // 결제정보(2)
                this.billingPayType = data.billingPayType;
                this.billingPayCompany = data.billingPayCompany;
                // 영수증발행
                this.billingReceiptType = data.billingReceiptType;
                // 결제일자
                // this.timeDate = moment().format('YYYY-MM-DD');
                this.timeDate = data.timeDate;
                // 등록자
                this.billingRegistStaffId = data.billingRegistStaffId;
                this.expenseCount = data.expenseCount;
                this.timeTime = '';
                // 메모
                this.memo = data.memo;
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        fetchGetEditExpenseList() {
            return api.get(`/admin/api/centerBill/expense/one/${this.centerId}/${this.billId}`);
        },
        // 수정요청
        async expenseEdit() {
            try {
                const { data } = await this.getExpenseEdit();
                alert('수정되었습니다.');
                await this.$router.push({ name: 'SalesExpense' });
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        // 수정요청 api
        getExpenseEdit() {
            return api.put('/admin/api/centerBill/expense', {
                centerId: this.centerId,
                centerBillingId: this.billId,
                expenseType: this.expenseType,
                expenseItem: this.editExpenseItem,
                expensePrice: this.getPureNumber(this.expensePrice),
                timeDate: this.timeDate,
                expenseCount: this.expenseCount,
                memo : this.memo,
            });
        },
        // 스태프목록 불러오기
        async onStaffList() {
            try {
                this.isLoading = true;
                const { data } = await this.getStaffList();
                data.sort((a, b) =>
                    // order by 정렬
                    a.name < b.name ? -1 : a.name > b.name ? 1 : 0
                );
                console.log('스태프', data);
                data.forEach((g) => {
                    this.staffList.push(g.name);
                    this.staffValueList.push(g.centerStaffId);
                });
                console.log('===> Success Loading centerList : ', data);
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        // 스태프목록 API
        getStaffList() {
            return api.get(`/admin/api/center/${this.centerId}/staff/teachers/list`);
        },
        // 판매시간설정
        updateDate(date) {
            // this.buyDate = date.replace(/\-/g,'');
            // console.log(this.buyDate);
            this.timeDate = date;
        },
        validateValues() {
            // 필수값 체크
            let result = false;
            const {
                expenseType,
                expenseItem,
                expensePrice,
                billingRegistStaffId,
                timeDate,
                billingPayType,
                directinput,
                expenseCount,
            } = this;
            let msg = '';

            // 지출구분
            if (expenseType === '' || expenseType === undefined) {
                msg = '지출구분을 선택하세요.';
                return { result, msg };
            }
            // 지출항목
            if ((directinput == false && expenseItem === '') || expenseItem === undefined) {
                msg = '지출항목을 입력하세요.';
                return { result, msg };
            }
            // 지출금액
            if (expensePrice === '' || expensePrice === undefined) {
                msg = '지출금액을 입력하세요.';
                return { result, msg };
            }

            // 지출수량
            if (expenseCount === '' || expenseCount === undefined) {
                msg = '지출수량을 입력하세요.';
                return { result, msg };
            }

            // 결제수단
            if (billingPayType === '' || billingPayType === undefined) {
                msg = '결제수단을 선택하세요.';
                return { result, msg };
            }
            // 결제일자
            if (timeDate === '' || timeDate === undefined) {
                msg = '결제일자를 선택하세요.';
                return { result, msg };
            }
            // 등록자
            if (billingRegistStaffId === '' || billingRegistStaffId === undefined) {
                msg = '등록자를 선택하세요.';
                return { result, msg };
            }

            if (msg !== '') {
                result = false;
            } else {
                result = true;
            }

            return { result, msg };
        },
        initType() {
            // 초기화 라디오 버튼 클릭시 초기화
            (this.itemValue = ''), (this.itemValue2 = '');
            this.itemValue3 = 0;
            this.expensePrice = 0;
        },
        getNumberFormat(num) {
            if (typeof num !== 'number' || num === undefined || num === '') {
                return num;
            }
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        onKeyUpPrice() {
            // 결제 금액 업데이트
            const num = this.getPureNumber(this.expensePrice);
            this.expensePrice = this.getNumberFormat(num);
        },
        getPureNumber(num) {
            if (typeof num !== 'string' || num === undefined || num === '') {
                return num;
            }
            return parseInt(num.toString().replace(/[,-]/g, ''));
        },
        isNumber(evt) {
            evt = evt || window.event;
            const charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
    },
};
</script>
<style lang="scss"></style>
